export default __webpack_public_path__ + "static/media/switch_on.23290c00.svg";